import Vue from 'vue'
import VueRouter from 'vue-router'

// Layout principale evento
import EventSite from '@/views/EventSite.vue'

// Pagine interne
import RegistrationPage from '@/pages/RegistrationPage.vue'
import LocationPage from '@/pages/LocationPage.vue'
import ContactPage from '@/pages/ContactPage.vue'
import ThankYouPage from '@/pages/ThankYouPage.vue'

Vue.use(VueRouter)

const routes = [

  {
    path: '/:slug',
    component: EventSite,
    props: true,

    children: [

      // /event/milano2026
      {
        path: 'registrations',
        name: 'Registration',
        component: RegistrationPage
      },

      // /event/milano2026/location
      {
        path: 'location',
        name: 'Location',
        component: LocationPage
      },

      // /event/milano2026/contatti
      {
        path: 'contatti',
        name: 'Contact',
        component: ContactPage
      },

      // /event/milano2026/thanks
      {
        path: 'thanks',
        name: 'ThankYou',
        component: ThankYouPage
      }

    ]
  },

  // redirect di default
  {
    path: '/',
    redirect: '/event/demo'
  },

  // fallback 404
  {
    path: '*',
    redirect: '/event/demo'
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

export default router
